import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import useProfile from "common/hooks/useProfile";
import { useContext } from "react";
import styled from "styled-components";
import GeminiContext from "./GeminiContext";

const Div = styled.div`
  position: fixed;
  right: 15px;
  bottom: 15px;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;

  button.btn {
    width: 50px;
    height: 50px;
    border-radius: 25px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--signal-grey-light);

    svg {
      font-size: 20px;
      color: var(--title-color);
    }
  }

  &.dark {
    button.btn {
      box-shadow: 0 2px 4px #000, 0 4px 8px rgba(0, 0, 0, 0.35),
        0 0 2px rgba(255, 255, 255, 0.1) !important;
    }
  }
`;

export function ChatButton() {
  const { setOpen } = useContext(GeminiContext);
  const profile = useProfile();

  if (!profile) {
    return null;
  }

  const isDark = login.isTheme("dark");

  return (
    <Div className={isDark ? "dark" : ""}>
      <button
        type="button"
        className="btn waves-effect"
        onClick={() => {
          setOpen((value) => !value);
        }}
      >
        <AutoAwesomeIcon />
      </button>
    </Div>
  );
}
